import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type ToolbarDividerProps = Pick<ComponentProps<'div'>, 'className'>;

export const ToolbarDivider = memo(({ className }: ToolbarDividerProps) => (
  <div className={cn('h-4 w-px shrink-0 ads:bg-ads-gray-4 bg-gray-5', className)} />
));
ToolbarDivider.displayName = 'ToolbarDivider';
